// extracted by mini-css-extract-plugin
module.exports = {"select":"SelectBox_select_IVMVk"};